import { render, staticRenderFns } from "./MaterialOutboundDetail.vue?vue&type=template&id=71dc1bba&scoped=true"
import script from "./MaterialOutboundDetail.vue?vue&type=script&lang=js"
export * from "./MaterialOutboundDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialOutboundDetail.vue?vue&type=style&index=0&id=71dc1bba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dc1bba",
  null
  
)

export default component.exports